export default __webpack_public_path__ + "static/media/javascript.01e3845c.png";